import React, { useState, useRef } from "react";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";

import QuestionTypeMenu from "./QuestionTypeMenu";
import CustomSplitButton from "./CustomSplitButton";
import CustomIconButton from "./CustomIconButton";
import { useTranslation } from "react-i18next";
import {
  Button,
  Dialog,
  DialogTitle,
  IconButton,
  Popover,
} from "@mui/material";

// Blue split create button
export default function AddButton({
  buttonId,
  addHandler,
  handleQuestionTreeApi,
  question,
}) {
  const [open, setOpen] = useState(false);
  const [showAll, setShowAll] = useState(true); // show all the question types
  const anchorRef = useRef(null);
  const [dialog, setDialog] = useState({
    open: false,
    state: { type: "conditional" },
  });
  const [selectedType, setSelectedType] = useState("slider");
  const { t } = useTranslation();

  // show menu with more questionTypes
  const handleOpen = () => setOpen(true);

  // close the menu
  const handleClose = () => setOpen(false);

  const handleItemClick = (type) => {
    handleClose();
    if (type === "conditional") {
      setDialog({ open: true, state: { type: "conditional" } });
      return;
    }
    setSelectedType(type);
    addHandler(type);
  };

  const handleCloseDialog = () =>
    setDialog({ open: false, state: { type: "null" } });

  const handleConditionalItemClick = (type) => {
    handleQuestionTreeApi({
      type: "INSERT_CONDITIONAL_AFTER",
      payload: { key: question.id ?? "", value: { type } },
    });
    handleCloseDialog();
  };

  // show more or less questionTypes
  const handleShowAll = () => setShowAll((prev) => !prev);

  return (
    <Box display="flex">
      {buttonId === "split-button" ? (
        <CustomSplitButton
          anchorRef={anchorRef}
          title={t(`editor.questionTypes.${selectedType}.addBtn`)}
          handleOpen={handleOpen}
          handleClick={() => {
            addHandler(selectedType);
            handleClose();
          }}
        />
      ) : (
        <CustomIconButton anchorRef={anchorRef} handleClick={handleOpen} />
      )}

      {/** Questiontype menu */}
      <Popover
        open={open}
        anchorEl={anchorRef.current}
        transition
        disablePortal
        style={{ zIndex: 1 }}
        anchorOrigin={
          buttonId === ""
            ? { vertical: "bottom", horizontal: "right" }
            : { vertical: "bottom", horizontal: "center" }
        }
        transformOrigin={
          buttonId === ""
            ? { vertical: "top", horizontal: "right" }
            : { vertical: "top", horizontal: "center" }
        }
      >
        <QuestionTypeMenu
          buttonId={buttonId}
          handleClose={handleClose}
          handleItemClick={handleItemClick}
          question={question}
          showAll={showAll}
          handleShowAll={handleShowAll}
        />
      </Popover>

      {/** Conditional dialog */}
      <Dialog open={dialog.open}>
        <Box
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <DialogTitle>
            {t("editor.questionTypes.conditional.info")}
          </DialogTitle>
          <Box mr={1}>
            <IconButton onClick={handleCloseDialog}>
              <CloseIcon />
            </IconButton>
          </Box>
        </Box>
        <QuestionTypeMenu
          buttonId={"conditional"}
          handleItemClick={handleConditionalItemClick}
          question={question}
          showAll={showAll}
          handleShowAll={handleShowAll}
        />
      </Dialog>
    </Box>
  );
}
